<script setup>
import {Auth} from "@/core/api/auth.js";
import {Processes} from "@/core/api/processes.js";
import {useAuthStore} from "@/stores/auth.js";
import {useCartStore} from "@/stores/cart.js";
import {useCompanyStore} from "@/stores/company.js";
import {useRoute, useRouter} from "vue-router";
import {onMounted, ref} from "vue";
import BaseFooter from "@/components/base/base-footer.vue";
import BaseHeader from "@/components/base/base-header.vue";
import {Orders} from "@/core/api/orders.js";
import {Wishlist} from "@/core/api/wishlist.js";
import {useWishlistStore} from "@/stores/wishlist.js";
import BaseBanner from "@/components/base/base-banner.vue";
import UiMessage from "@/components/ui/ui-message.vue";

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const cartStore = useCartStore()
const companyStore = useCompanyStore()
const wishlistStore = useWishlistStore()


const isMessageOpen = ref(true)
const closeMessage = () => {
  isMessageOpen.value = false
}

const checkUserAuth = async () => {
  const [res, companyRes] = await Promise.all([Auth.refresh(), Processes.getCompanyInfo()]);

  if (companyRes) {
    companyStore.setCompanyInfo(companyRes.data.parameters)
  }

  if (res.data) {
    authStore.setUser({
      user: res.data.refreshJwtToken.user,
      accessToken: res.data.refreshJwtToken.accessToken
    })

    // if (res.data.refreshJwtToken.user.language !== translation.currentLocale) {
    //   translations.switchLanguage(res.data.refreshJwtToken.user.language)
    //   await router.push({
    //     name: route.name,
    //     params: {
    //       locale: localStorage.getItem('fpt-user-locale') || 'en-gb'
    //     }
    //   })
    // }

    localStorage.setItem('fpt-refresh', res.data.refreshJwtToken.refreshToken)

    const currentOrder = await Orders.getOrders("PENDING", res.data.refreshJwtToken.accessToken, res.data.refreshJwtToken.user.email)
    cartStore.setCurrentOrders(currentOrder.data.orders.edges[0].node)

    const wishlistRes = await Wishlist.getWishlist(res.data.refreshJwtToken.accessToken)
    wishlistStore.wishlist = wishlistRes.data.wishlists.edges[0].node
  }
}

onMounted(async () => {
  await checkUserAuth()

  setInterval(async () => {
    await checkUserAuth()
  }, 600000)
})
</script>

<template>
  <div class="main" id="top">
<!--    <base-banner />-->
    <base-header />
<!--    <Transition name="opacity" mode="out-in">-->
<!--      <ui-message-->
<!--          @close-modal="closeMessage"-->
<!--          v-if="isMessageOpen"-->
<!--      />-->
<!--    </Transition>-->
    <RouterView v-slot="{ Component }" class="page">
      <Transition name="opacity" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
    <base-footer />
  </div>
</template>

<style lang="scss">
.page {
  position: relative;
  //top: -97px;
}

.swiper-pagination {
  bottom: 0 !important;
  width: fit-content !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  border-radius: 6px !important;
  opacity: 0.9 !important;
  background-color: $white !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 5px 10px !important;
}
.swiper-pagination-bullet {
  transition: 0.2s !important;
  background-color: #5B194F !important;
  opacity: 1 !important;
  width: 12px !important;
  height: 12px !important;
}
.swiper-pagination-bullet-active {
  background: linear-gradient(90deg, #5A194E 0%, #FB81F7 100%) !important;
  width: 24px !important;
  height: 12px !important;
  border-radius: 36px !important;
}

.el-breadcrumb__inner {
  text-transform: capitalize !important;
  color: #696969 !important;
  font-family: Inter, sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
}

.el-scrollbar__bar {
  right: 15px;
}
.el-scrollbar__thumb {
  background-color: #454647;
  opacity: 1;
}

.el-rate {
  gap: 2px !important;
}
.el-rate .el-rate__icon {
  margin-right: 1px;
  font-size: 26px;
}
.el-rate .el-rate__icon.is-active {
  color: #FFCF96;
}

@media (max-width: 800px) {
  .el-scrollbar__bar {
    display: none;
  }
}
</style>
